import React, { useEffect, useState } from 'react';
import { axiosInstance as axios } from '../../../context/AuthContext';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '../../ui/dialog';
import { Button } from '../../ui/button';

export function FulfillDialog({ req, onClose, onConfirm }) {
  const [pros, setPros] = useState([]);
  const [proId, setProId] = useState('');
  const [message, setMessage] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!req) return;
    setProId(''); setMessage('');
    axios.get('/api/admin/professionals').then(r => setPros((r.data || []).filter(p => p.is_active))).catch(() => setPros([]));
  }, [req]);

  const submit = async () => {
    setSaving(true);
    await onConfirm(req, { professional_id: proId || null, message: message.trim() || null });
    setSaving(false);
  };

  return (
    <Dialog open={!!req} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="sm:max-w-md" data-testid="fulfill-dialog">
        <DialogHeader>
          <DialogTitle>Mark as fulfilled</DialogTitle>
          <DialogDescription>{req?.user_name} will get an email and an in-app notice that their request is fulfilled.</DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <div>
            <label className="text-sm font-medium text-gray-700 mb-1 block">Professional you found (optional)</label>
            <select value={proId} onChange={e => setProId(e.target.value)} className="w-full border rounded-md p-2 text-sm" data-testid="fulfill-pro-select">
              <option value="">— Don't name a professional —</option>
              {pros.map(p => <option key={p.professional_id} value={p.professional_id}>{p.name}{p.location ? ` · ${p.location}` : ''}</option>)}
            </select>
          </div>
          <div>
            <label className="text-sm font-medium text-gray-700 mb-1 block">Personal note to the family (optional)</label>
            <textarea value={message} onChange={e => setMessage(e.target.value)} rows={3} maxLength={500} className="w-full border rounded-md p-2 text-sm" placeholder="e.g. She specializes in Georgia family records." data-testid="fulfill-message-input" />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Cancel</Button>
          <Button onClick={submit} disabled={saving} className="bg-green-600 hover:bg-green-700" data-testid="fulfill-confirm-btn">
            {saving ? 'Sending…' : 'Fulfill & notify family'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
